export default __webpack_public_path__ + "static/media/testifyFive.b3a98bb6.png";